import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommonFileUploadComponent } from './common-file-upload.component';

const routes: Routes = [{ path: '', component: CommonFileUploadComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonFileUploadRoutingModule { }
